import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { canOpenInbox } from '@technologyadvice/relay-frontend'
import { pusherKey } from './keyProvider'

// Every tab holds a Pusher connection against a shared plan, so only someone with a bell opens one:
// not the login pages, not clients.
export const connectRealtimeFor = user => {
    if (window.Echo || !user || !canOpenInbox(user)) {
        return
    }

    window.Pusher = Pusher
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: pusherKey(),
        cluster: 'us2',
        encrypted: true,
    })
}
